import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppInputComponent, InputType } from 'src/app/shared/components/app-input/app-input.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppCardsResgatarComponent } from 'src/app/shared/components/app-cards-resgatar/app-cards-resgatar.component';
import { CardsResgatar } from 'src/app/shared/models/cardsResgatar';
import { PartnerService } from 'src/app/core/services/partner.service';
import { CommonService } from 'src/app/core/services/common.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { Router } from '@angular/router';
import { CouponService } from 'src/app/core/services/coupon.service';

@Component({
  selector: 'app-parcerias',
  standalone: true,
  imports: [CommonModule, AppButtonComponent, AppInputComponent, ReactiveFormsModule, AppCardsResgatarComponent],
  templateUrl: './parcerias.component.html',
  styleUrl: './parcerias.component.scss'
})
export class ParceriasComponent implements OnInit {
  labelColor = 'white';
  itemsFiltered: any;
  itemsInvalidFiltered: any;
  filterGroup = new FormGroup({
    filterControl: new FormControl<string>('')
  });

  buttonBackOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  titleInvalid = "Cupons Utilizados";
  partners: any;

  items: CardsResgatar[] = [];
  itemsInvalid: CardsResgatar[] = [];
  clubCoupons: CardsResgatar[] = [];
  clubCouponsFiltered: CardsResgatar[] = [];

  constructor(
    private partnerService: PartnerService,
    private couponService: CouponService,
    private commonService: CommonService,
    private location: Location,
    private router: Router,
    private alertService: AlertService,
  ) { }

  filter() {
    let textFilter = this.filterGroup.get('filterControl')?.value;
    if (textFilter && textFilter?.length >= 2) {
      this.itemsFiltered = this.items.filter(a => a.title.toLowerCase().includes(textFilter.toLowerCase()));
      this.itemsInvalidFiltered = this.itemsInvalid.filter(a => a.title.toLowerCase().includes(textFilter.toLowerCase()));
      this.clubCouponsFiltered = this.clubCoupons.filter(a => a.title.toLowerCase().includes(textFilter.toLowerCase()));
    } else {
      this.itemsFiltered = this.items;
      this.itemsInvalidFiltered = this.itemsInvalid;
      this.clubCouponsFiltered = this.clubCoupons;
    }
  }

  ngOnInit(): void {
    this.validateAccess();
    this.getPartners();
    const memberId = this.getMemberId();
    this.getClubCoupons(memberId);
  }

  getPartners() {
    this.partnerService.getAllPartners().subscribe((partners: any) => {
      this.partners = partners.content;
      this.partners.forEach((partner: any) => {
        partner.src = this.commonService.getImageStr(partner?.document?.id);
      });
      this.setItemsFiltered(this.partners);
    });
  }

  getClubCoupons(memberId: string) {
    this.couponService.getMemberCoupons(memberId).subscribe((coupons: any) => {
      this.clubCoupons = coupons.map((coupon: any) => ({
        topIcon: false,
        image: '',
        title: coupon.couponName || '',
        content: `Válido até ${new Date(coupon.validity).toLocaleDateString()}`,
        valid: `Válido até ${new Date(coupon.validity).toLocaleDateString()}`,
        point: coupon.usageLimit - coupon.usedQuantity,
        cupom: coupon.couponName,
        value: `R$ ${coupon.value.toFixed(2).replace('.', ',')}`,
        usageTypes: coupon.usageTypes.map((type: string) => this.mapUsageType(type)).join(', '),
        inactiveItem: !coupon.isActive,
        inactiveButton: coupon.usageLimit <= coupon.usedQuantity,
        link: '#',
        isCuponClube: true
      }));
      this.clubCouponsFiltered = this.clubCoupons;
    });
  }

  private mapUsageType(type: string): string {
    switch (type) {
      case 'NEW':
        return 'Adesão';
      case 'RENEW':
        return 'Renovação';
      case 'EARLY_RENEW':
        return 'Renovação Antecipada';
      case 'UPGRADE':
        return 'Upgrade';
      default:
        return type;
    }
  }

  setItemsFiltered(partners: any) {
    this.items = partners.map((item: any) => {
      const image = item.src || '';
      const value = item.isPercentualDiscount !== null && item.isPercentualDiscount !== undefined
        ? (item.isPercentualDiscount ? `${item.discount || 0}%` : `R$ ${(item.discount || 0).toFixed(2).replace('.', ',')}`)
        : 'Desconto não disponível';

      return {
        topIcon: false,
        image,
        title: item.partnerName || '',
        content: item.description ? item.description.replaceAll('\n', '<br />') : '',
        valid: 'Válido até 24/04',
        point: item.points || '',
        cupom: item.cupom || '',
        value,
        inactiveItem: !item.isActive,
        inactiveButton: false,
        link: item.link || '#',
        isCuponClube: false
      };
    });

    this.itemsFiltered = [...this.items];
    this.itemsInvalidFiltered = this.itemsInvalid;
  }

  private validateAccess(): void {
    const activeSections = localStorage.getItem('activeSections');

    if (!activeSections) {
      this.handleAccessDenied();
      return;
    }

    const parsedSections = JSON.parse(activeSections);

    if (!parsedSections['parceiros']) {
      this.handleAccessDenied();
    }
  }

  private handleAccessDenied(): void {
    this.alertService.showAlert(AlertType.WARNING, 'Você não possui acesso a essa página');
    this.router.navigate(['/dashboard']);
  }

  back() {
    this.location.back();
  }

  private getMemberId(): string {
    const currentUser = localStorage.getItem('current-user');
    if (currentUser) {
      try {
        const parsedUser = JSON.parse(currentUser);
        return parsedUser.id;
      } catch (error) {
        console.error('Erro ao parsear o current-user do localStorage:', error);
      }
    }
    return '';
  }
}